import { gql } from "graphql-request";

import { USERS_COLUMNS } from "@onesolution/constants";
import type { Context } from "@onesolution/middlewares";
import {
	ALL_MONDAY_SCHEMAS,
	MONDAY_SCHEMAS,
	type MONDAY_TYPES,
} from "@onesolution/monday";
import { requestAndFormat } from "../utils";

export const userInfoByEmailQuery = (context: Context, email: string) =>
	requestAndFormat(
		{
			defaultParams: {
				boardId: context.boards?.users,
				columnIds: [
					USERS_COLUMNS.active,
					USERS_COLUMNS.firstname,
					USERS_COLUMNS.lastname,
					USERS_COLUMNS.email,
					USERS_COLUMNS.role,
					USERS_COLUMNS.services,
					USERS_COLUMNS.favoriteServices,
				],
				compareColumnId: USERS_COLUMNS.email,
			},
			gql: gql`
				query GetUserInfoByEmail($boardId:ID!, $columnIds:[String!], $email: CompareValue!, $compareColumnId: ID!) {
					boards(ids: [$boardId]) {
						id
						name
						items_page(query_params: { rules: { compare_value: $email, column_id: $compareColumnId } }) {
							items {
								id
								name
								${MONDAY_SCHEMAS.assets}
								
								column_values(ids: $columnIds) {
									${ALL_MONDAY_SCHEMAS}

									 ... on BoardRelationValue {
                                        linked_item_ids
                                    }
								}
							}
						}
					}
				}`,
			resultKey: "boards[0].items_page.items",
			outType: {} as MONDAY_TYPES["base"] &
				MONDAY_TYPES["assets"] & {
					active: MONDAY_TYPES["checkbox"];
					firstname: MONDAY_TYPES["text"];
					lastname: MONDAY_TYPES["text"];
					name: MONDAY_TYPES["email"];
					status: MONDAY_TYPES["status"];
					favoriteServices: { linked_item_ids: string[] };
					services: { linked_item_ids: string[] };
				},
		},
		{ email },
	);
